export default "__VITE_ASSET__jTFVGMXB__"